<template>
  <div
    class="goodsManageSet"
    :class="{ fixedStyle: isShowStyle }"
    :style="{ top: scrollTop + 'px' }"
  >
    <div class="banner">
      <img src="../../../assets/images/banner1.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon">
        <i class="iconfont icon-shangpinsku"></i>
      </div>
      <div class="breadcrumb_item">SKU管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">商品管理</div>
    </div>

    <div class="main_content">
      <div class="tit">销售参数设置</div>
      <div class="block">
        <h1><span class="mark">*</span>商品零售分销底价（/件）</h1>
        <p class="mark" style="font-size: 11px; margin-bottom: 10px">该参数将影响分销合作场景内的价格核算，如需使用，请认真填写</p>
        <div class="input_box" @click="handleShowDialog('cbprice')">
          <van-field
            v-model="formData.cbprice"
            type="number"
            placeholder="请输入商品零售分销底价（/件）"
            @focus="inputFocus"
            @blur="inputBlur('cbprice')"
            maxlength="15"
            readonly
          />
        </div>
      </div>

      <div class="block">
        <h1><span class="mark">*</span>商品基础零售价（/件）</h1>
        <div class="input_box">
          <van-field
            v-model="formData.price"
            type="number"
            placeholder="请输入商品基础零售价（/件）"
            @focus="inputFocus"
            @blur="inputBlur('ls', formData.price)"
            maxlength="15"
            :readonly="!isAllowEditPrice"
          />
        </div>
      </div>
      <div class="block">
        <h1><span class="mark">*</span>商品批发（团批）分销底价（/件）</h1>
        <p class="mark" style="font-size: 11px; margin-bottom: 10px">该参数将影响分销合作场景内的价格核算，如需使用，请认真填写</p>
        <div class="input_box" @click="handleShowDialog('pfprice')">
          <van-field
            v-model="formData.pfprice"
            type="number"
            placeholder="请输入商品批发（团批）分销底价（/件）"
            @focus="inputFocus"
            @blur="inputBlur('pfprice')"
            maxlength="10"
            readonly
          />
        </div>
      </div>
      <div class="block">
        <h1><span class="mark">*</span>商品基础批发价（团批）价（/件）</h1>
        <div class="input_box">
          <van-field
            v-model="formData.groupprice"
            type="number"
            placeholder="请输入商品基础批发价（团批）价（/件）"
            @focus="inputFocus"
            @blur="inputBlur('pf', formData.groupprice)"
            maxlength="10"
            :readonly="!isAllowEditGroupprice"
          />
        </div>
      </div>

      <div class="block">
        <h1>营销静态标价（纯静态展示用）</h1>
        <div class="input_box">
          <van-field
            v-model="formData.salesbj"
            type="number"
            placeholder="请输入营销静态标价"
            @focus="inputFocus"
            @blur="inputBlur"
            maxlength="10"
          />
        </div>
      </div>

      <div class="block">
        <van-divider
          :dashed="true"
          :style="{ borderColor: '#ccc', padding: '0 .7rem' }"
        />
      </div>

      <div class="block">
        <h1>商品普通用户积分兑换值（/件）</h1>
        <div class="input_box">
          <van-field
            type="number"
            v-model="formData.userscore1"
            placeholder="请输入普通用户积分兑换值（/件）"
            @focus="inputFocus"
            @blur="inputBlur"
            maxlength="15"
          />
        </div>
      </div>

      <div class="block">
        <h1>商品商务合作用户积分兑换值（/件）</h1>
        <div class="input_box">
          <van-field
            type="number"
            v-model="formData.userscore2"
            placeholder="请输入商品商务合作用户积分兑换值（/件）"
            @focus="inputFocus"
            @blur="inputBlur"
            maxlength="15"
          />
        </div>
      </div>

      <div class="block">
        <h1>商品企业积分兑换值（/件）</h1>
        <div class="input_box">
          <van-field
            type="number"
            v-model="formData.userscore3"
            placeholder="请输入企业积分兑换值（/件）"
            @focus="inputFocus"
            @blur="inputBlur"
            maxlength="15"
          />
        </div>
      </div>

      <div class="block">
        <van-divider
          :dashed="true"
          :style="{ borderColor: '#ccc', padding: '0 .7rem' }"
        />
      </div>

      <div class="block">
        <h1><span class="mark">*</span>单款混选起批数量（件/起批）</h1>
        <div class="input_box">
          <van-field
            type="number"
            v-model="formData.startnum1"
            placeholder="请输入商品单样单选起批数量（件/起批）"
            @focus="inputFocus"
            @blur="inputBlur"
            maxlength="5"
          />
        </div>
      </div>

      <!-- <div class="block">
        <h1>混样多选起批数量（组/起批）</h1>
        <div class="input_box">
          <van-field
            type="number"
            v-model="formData.startnum2"
            placeholder="请输入商品混样多选起批数量起批数量（组/起批）"
            @focus="inputFocus"
            @blur="inputBlur"
            maxlength="5"
          />
        </div>
      </div> -->

      <div class="block">
        <van-divider
          :dashed="true"
          :style="{ borderColor: '#ccc', padding: '0 .7rem' }"
        />
      </div>

      <div class="block">
        <h1><span class="mark">*</span>是否限购</h1>
        <div class="radio_box">
          <van-radio-group
            v-model="formData.islimit"
            @change="handleRadioLimit"
          >
            <van-radio name="不限购">不限购</van-radio>
            <van-radio name="限购">
              <div class="flex-rowl limit_content">
                限购
                <van-field
                  v-model="formData.limitnum"
                  type="digit"
                  placeholder="请输入每位用户限购数量"
                  maxlength="2"
                  class="van_input"
                />
              </div>
            </van-radio>
          </van-radio-group>
        </div>
      </div>

      <div class="block">
        <h1><span class="mark">*</span>是否上架</h1>
        <div class="radio_box">
          <van-radio-group
            direction="horizontal"
            v-model="formData.commoditystate"
          >
            <van-radio name="上架">上架</van-radio>
            <van-radio name="下架">下架 </van-radio>
          </van-radio-group>
        </div>
      </div>

      <div class="block">
        <h1><span class="mark">*</span>销售状态</h1>
        <div class="radio_box">
          <van-radio-group direction="horizontal" v-model="formData.salestate">
            <van-radio name="正常销售">正常销售</van-radio>
            <van-radio name="已售罄">已售罄 </van-radio>
          </van-radio-group>
        </div>
      </div>

      <div class="block">
        <h1><span class="mark">*</span>是否参与分销合作服务？</h1>
        <div class="radio_box">
          <van-radio-group direction="horizontal" v-model="formData.isjoindevide">
            <van-radio :name="1">参与分销合作服务</van-radio>
            <van-radio :name="0">不参与分销合作服务 </van-radio>
          </van-radio-group>
        </div>
      </div>
    </div>

    <div class="primary-button" @click="query">保存确认</div>
    <div class="primary-button return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i>返回
    </div>

    <!-- 弹窗 start -->
    <van-dialog
      v-model="isShowDialog"
      title="参考价"
      show-cancel-button
      :before-close="handleBeforeClose"
      @confirm="handleConfirm"
    >
      <div class="input_box dialog">
        <van-field
          type="number"
          v-model="priceDialog"
          placeholder="请输入商品价格"
        />
      </div>
    </van-dialog>
    <!-- 弹窗 end -->
  </div>
</template>

<script>
import {
  getCommidityDetail,
  editCommidity,
  encryptstringview,
  getShopYijia,
} from "../../../api/api";
import {
  getShopConfig,
  getShopCbPrice,
  getShopTuanPrice,
} from "../../../api/shop";
import { mapState } from "vuex";
import { calculator } from "../../../utils/decimal";
export default {
  name: "cSalesParams",
  data() {
    return {
      radio: "",
      searchText: "",
      isShowStyle: false,
      scrollTop: 0,

      isShowType: 1,
      isShow: false,
      columnsGoodsType: [
        "普通商品",
        "普通用户积分礼品",
        "商务用户积分礼品",
        "企业积分商品",
      ],
      columnsGoodsSettleType: [
        "零售购买",
        "普通用户积分兑换",
        "商户合作用户积分兑换",
        "企业积分",
      ],

      detail: "",
      // 是否允许修改商品零售价
      isAllowEditPrice: false,
      // 是否允许修改批发参考价
      isAllowEditGroupprice: false,
      formData: {
        Method: "ams_shop_commodity_edit",
        id: "",

        cbprice: "", // 成本参考价
        price: "", // 零售
        pfprice: "",
        groupprice: "", // 批发价
        salesbj: "",
        userscore1: "", // 普通用户积分兑换值
        userscore2: "", // 商务合作用户积分兑换值
        userscore3: "", // 企业积分兑换值
        startnum1: "", // 单样单选起始批发购买数量
        // startnum2: "", // 混样多选起始批发购买数量
        islimit: "", // 是否限购 = 限购  不限购
        limitnum: "", // 限购数量
        commoditystate: "", // 状态 = 上架 下架
        salestate: "", // 销售状态 = 正常销售 已售罄
        isjoindevide: '',  // 是否参与分销合作服务
      },

      typeDialog: "",
      priceDialog: "", // 弹窗价格
      isShowDialog: false,
      cmid: "",
      qyguid: "",
      shopDYijia: 0, // 零售溢价
      shopTYijia: 0, // 团批溢价
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.qyguid = USERINFO.qy.qyguid;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.cmid = id;
        this.getDetail();
        this.getShopYijia();
        this.getShopConfig();
      } else {
        this.$router.back();
      }
    },

    // 权限管理
    getShopConfig() {
      getShopConfig({ columncode: "shopprice" }).then((res) => {
        res.forEach((v) => {
          if (v.evalue == "是否允许商户自行修改零售价格") {
            this.isAllowEditPrice = v.detailvalue == 0 ? false : true;
          } else if (v.evalue == "是否允许商户自行修改团购价格") {
            this.isAllowEditGroupprice = v.detailvalue == 0 ? false : true;
          }
        });
      });
    },
    // 商品溢价管理--商品支付价格的计算
    getShopYijia() {
      getShopYijia({ qyguid: this.qyguid }).then((res) => {
        if (res.length > 0) {
          let obj = res[0];
          this.shopDYijia = obj.detailvalue ? obj.detailvalue : 0;
          this.shopTYijia = obj.detailvalue2 ? obj.detailvalue2 : 0;
        }
      });
    },
    getDetail() {
      let { cmid } = this;
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getCommidityDetail({ id: cmid }).then((res) => {
        this.detail = res;
        this.formData.id = res.id ? res.id : "";
        this.formData.cbprice = res.cbprice ? res.cbprice : "";
        this.formData.price = res.price ? res.price : "";
        this.formData.pfprice = res.pfprice ? res.pfprice : "";
        this.formData.groupprice = res.groupprice ? res.groupprice : "";
        this.formData.salesbj = res.salesbj ? res.salesbj : "";
        this.formData.userscore1 = res.userscore1 ? res.userscore1 : "";
        this.formData.userscore2 = res.userscore2 ? res.userscore2 : "";
        this.formData.userscore3 = res.userscore3 ? res.userscore3 : "";
        this.formData.startnum1 = res.startnum1 ? res.startnum1 : "";
        this.formData.islimit = res.islimit ? res.islimit : "不限购";
        this.formData.limitnum = res.limitnum ? res.limitnum : "";
        this.formData.commoditystate = res.commoditystate
          ? res.commoditystate
          : "下架";
        this.formData.salestate = res.salestate ? res.salestate : "正常销售";
        this.formData.isjoindevide = res.isjoindevide
          ? parseInt(res.isjoindevide)
          : '';


        Toast.clear();
      });
    },
    // 获取商品成本价
    getShopCbPrice() {
      let { priceDialog, qyguid } = this;
      if (priceDialog == "") {
        this.$toast("请输入参考价格");
        return;
      }
      getShopCbPrice({ cmprice: priceDialog, qyguid }).then((res) => {
        if (res.result) {
          this.formData.cbprice = priceDialog;
          this.formData.price = res.msg;
        }
      });
    },
    // 获取商品成本价
    getShopTuanPrice() {
      let { priceDialog, qyguid } = this;
      if (priceDialog == "") {
        this.$toast("请输入参考价格");
        return;
      }
      getShopTuanPrice({ cmprice: priceDialog, qyguid }).then((res) => {
        if (res.result) {
          this.formData.pfprice = priceDialog;
          this.formData.groupprice = res.msg;
        }
      });
    },

    // 获得焦点
    inputFocus(e) {
      this.scrollTop = "-" + (e.srcElement.getBoundingClientRect().top - 200);
      this.isShowStyle = true;
    },
    // 失去焦点
    inputBlur(type, price) {
      if (type == "cbprice") {
        this.getShopCbPrice();
      } else if (type == "pfprice") {
        this.getShopTuanPrice();
      }
      let { detail } = this;
      if (detail.publishtype == "企业合作商家发布") return;
      // this.debouncedChange(type, price);
      console.log(type, price);
      this.isShowStyle = false;
    },
    // 防抖函数
    debouncedChange(name, value) {
      let { shopDYijia, shopTYijia, formData } = this;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        if (name == "ls") {
          // 商品零售价限制 > 零售参考价 + 零售参考价*零售溢价
          let price = calculator(formData.cbprice)
            .add(
              calculator(formData.cbprice).multiply(
                calculator(shopDYijia).multiply(0.01)
              )
            )
            .toNumber();
          if (value < price) {
            this.formData.price = "";
            this.$toast("设置价格不能低于 \n 零售底价");
          }
        } else if (name == "pf") {
          // 商品零售价限制 > 零售参考价 + 零售参考价*零售溢价
          let price = calculator(formData.pfprice)
            .add(
              calculator(formData.pfprice).multiply(
                calculator(shopTYijia).multiply(0.01)
              )
            )
            .toNumber();
          if (value < price) {
            this.formData.groupprice = "";
            this.$toast("设置价格不能低于 \n 批发（团批）底价");
          }
        }
        // 价格核算
      }, 500); // 设置延迟时间，单位为毫秒
    },
    handleReturn() {
      history.back();
    },
    handleBeforeClose(action, done) {
      let { priceDialog } = this;
      if (action == "cancel") {
        done(true);
      } else {
        if (priceDialog != "") {
          this.priceDialog = "";
          done(true);
          return;
        }
        done(false);
      }
    },
    handleShowDialog(type) {
      this.typeDialog = type;
      this.isShowDialog = true;
    },
    handleConfirm() {
      let type = this.typeDialog;
      if (type == "cbprice") {
        this.getShopCbPrice();
      } else if (type == "pfprice") {
        this.getShopTuanPrice();
      }
    },

    handleRadioLimit(e) {
      if (e == "限购") {
        this.formData.limitnum = this.formData.limitnum
          ? this.formData.limitnum
          : 1;
      } else {
        this.formData.limitnum = "";
      }
    },

    query() {
      let {shopDYijia, shopTYijia, formData, detail } = this;
      // 商品零售价限制 > 零售参考价 + 零售参考价*零售溢价
       console.log(shopTYijia, shopDYijia,);
      // let price = calculator(formData.cbprice)
      //   .add(
      //     calculator(formData.cbprice).multiply(
      //       calculator(shopDYijia).multiply(0.01)
      //     )
      //   )
      //   .toNumber();
      // let price1 = calculator(formData.pfprice)
      //   .add(
      //     calculator(formData.pfprice).multiply(
      //       calculator(shopTYijia).multiply(0.01)
      //     )
      //   )
      //   .toNumber();
      if (formData.cbprice == "") {
        this.$toast("请输入零售分销底价最少2个字符");
        return;
      }
      if (formData.price == "") {
        this.$toast("请输入基础零售价最少2个字符");
        return;
      }
      // if (formData.price <= price) {
      //   this.formData.price = "";
      //   this.$toast("设置价格不能低于等于 \n 零售底价");
      //   return;
      // }
      if (formData.pfprice == "") {
        this.$toast("请输入商品批发（团批）分销底价");
        return;
      }
      if (formData.groupprice == "") {
        this.$toast("请输入商品基础批发价");
        return;
      }

      // if (formData.groupprice <= price1) {
      //   this.formData.groupprice = "";
      //   this.$toast("设置价格不能低于等于 \n 批发（团批）底价");
      //   return;
      // }

      if (formData.userscore1 != "") {
        if (formData.userscore1.length < 2) {
          this.$toast("请输入普通用户积分兑换值最少2个字符");
          return;
        }
      }
      if (formData.userscore2 != "") {
        if (formData.userscore2.length < 2) {
          this.$toast("请输入商务合作用户积分兑换值最少2个字符");
          return;
        }
      }
      if (formData.userscore3 != "") {
        if (formData.userscore3.length < 2) {
          this.$toast("请输入企业积分兑换值最少2个字符");
          return;
        }
      }
      if (formData.startnum1 == "" && formData.startnum1.length < 1) {
        this.$toast("请输入单样单选起始批发购买数量最少2个字符");
        return;
      }
      if (formData.isjoindevide == "" && formData.isjoindevide != 0) {
        this.$toast("请选择是否参与分销合作服务");
        return;
      }
      // if (formData.startnum2 != "") {
      //   if (formData.startnum2.length < 2) {
      //     this.$toast("请输入混样多选起始批发购买数量最少2个字符");
      //     return;
      //   }
      // }
      if (formData.commoditystate == "上架") {
        if (detail.runmsg.orderrule == "" || detail.runmsg2.orderrule == "") {
          this.$toast("请先设置物流信息");
          return;
        }
      }
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      editCommidity(formData).then((res) => {
        let data = res;
        if (data.result) {
          setTimeout(() => {
            Toast.clear();
            this.$toast.success(data.message);
          }, 500);
          // setTimeout(() => {
          //   history.back();
          // }, 1500);
        } else {
          this.$toast.fail(data.message || "服务器报错，请稍后～");
        }
      });
    },
    // 图片路径的分割
    imgSplit(url) {
      if (url != "") {
        if (url.indexOf("upload")) {
          let splitArr = url.split("/upload/");
          return splitArr[splitArr.length - 1];
        } else if (url.indexOf("Upload")) {
          let splitArr = url.split("/Upload/");
          return splitArr[splitArr.length - 1];
        }
      } else {
        return "";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  padding-bottom: 420px;
  .breadcrumb {
    padding-bottom: 60px;
  }
  .main_content {
    .tit {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .block {
      margin-bottom: 80px;
      .limit_content {
        white-space: nowrap;
        .van_input {
          border: 1px solid #adadadc2;
          margin-left: 30px;
          border-radius: 45px;
          padding: 6px 10px;
        }
      }
      h1 {
        text-align: center;
        font-weight: 400;
        margin-bottom: 20px;
        font-size: 30px;
      }
      .img_box {
        margin: auto;
        margin-top: 40px;
        text-align: center;
      }
      p {
        font-size: 22px;
        text-align: center;
        &.red {
          color: #ff0012;
        }
      }
    }
  }
  .input_box.dialog {
    width: 500px;
    margin: 40px auto 70px;
  }
}
</style>